import { FC } from 'react'

import { Document, Page } from '@react-pdf/renderer'
import { PrintablePurchaseOrderQuery } from 'generated/resources/graphql'

import Footer from './Footer'
import Header from './Header'
import Info from './Info'
import Table from './Table'

interface Props {
  locale: string
  logo: string | null
  purchaseOrder: PrintablePurchaseOrderQuery['procurement']['purchaseOrdersConnection']['nodes'][number]
}

const PrintablePurchaseOrder: FC<Props> = ({ purchaseOrder, locale, logo }) => {
  const { id, formattedPoNumber, date, deadline, vendor, legalEntity, description, cost } =
    purchaseOrder

  return (
    <Document title={`Purchase order #${id}`}>
      <Page
        size="A4"
        style={{
          fontFamily: 'Inter',
          color: '#1E1E31',
          padding: '56px 48px',
          gap: 32,
          flexDirection: 'column',
        }}
      >
        <Header formattedPoNumber={formattedPoNumber} date={date} deadline={deadline} logo={logo} />
        <Info vendor={vendor} legalEntity={legalEntity} />
        <Table description={description} cost={cost} locale={locale} />
        <Footer />
      </Page>
    </Document>
  )
}

export default PrintablePurchaseOrder
